export { default as Img200 } from './processed/200/homeofthebrave.jpg';
export { default as Img400 } from './processed/400/homeofthebrave.jpg';
export { default as Imgthumb } from './processed/thumb/homeofthebrave.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/homeofthebrave.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/homeofthebrave.jpg';
export const ImgData = { width: 600, height: 400, ratio: 0.6666666666666666, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      47,
      99,
      221
    ],
    "_population": 282,
    "_hsl": [
      0.6168582375478927,
      0.71900826446281,
      0.5254901960784314
    ]
  },
  "LightVibrant": {
    "_rgb": [
      132,
      204,
      252
    ],
    "_population": 2,
    "_hsl": [
      0.5666666666666667,
      0.9523809523809526,
      0.7529411764705882
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      84,
      36,
      17
    ],
    "_population": 19,
    "_hsl": [
      0.0472636815920398,
      0.6633663366336634,
      0.1980392156862745
    ]
  },
  "Muted": {
    "_rgb": [
      158,
      111,
      93
    ],
    "_population": 412,
    "_hsl": [
      0.04615384615384616,
      0.25896414342629487,
      0.49215686274509807
    ]
  },
  "LightMuted": {
    "_rgb": [
      145,
      145,
      193
    ],
    "_population": 389,
    "_hsl": [
      0.6666666666666666,
      0.27906976744186046,
      0.6627450980392157
    ]
  },
  "DarkMuted": {
    "_rgb": [
      66,
      45,
      35
    ],
    "_population": 271,
    "_hsl": [
      0.05376344086021504,
      0.3069306930693069,
      0.19803921568627453
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/homeofthebrave.js